import { defineMessage } from 'services/localization';

export const messages = {
    sectionHeaderText: defineMessage('billed_status'),
    unmarkAsBilledMenuItemText: defineMessage('unmark_as_billed'),
    billedStatus: defineMessage('billed'),
    markAsBilled: defineMessage('mark_as_billed'),
    markAsBilledButtonTitle: defineMessage('mark_this_purchase_order_as_billed'),
    unmarkAsBilledMenuItemTitle: defineMessage('unmark_this_purchase_order_as_billed'),
};
